<template lang="pug">
img.icon-plus(src="~assets/plus.png")
  
</template>
<script>
export default {
  name: 'IconPlus',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.icon-plus
  width: 100%
  height: 100%
</style>
